import React from "react";
import { withTheme } from "@material-ui/core/styles"
import { 
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography, 
  Tooltip,

} from "@material-ui/core"
import TakeAwayIcon from "../../common/assets/smallTakeAwayIcon@3x.png"
import DeliveryIcon from "../../common/assets/smallDeliveryIcon@3x.png"
import {Cell, PieChart, Pie, LabelList, ResponsiveContainer, Legend} from "recharts"
import Util from "../../common/Util"

class StatCard extends React.PureComponent{
  constructor(props){
    super(props)
  }
/*
 stsDate:"18/05/2020",
  stsOrdersQt:20,
  stsTotal:5340,
  stsTakeAwayQt:16,
  stsDeliveryQt:4,
  stsCashQt:4,
  stsCardQt:16
*/
  // renderTypeLegend({payload}){
  //   console.log("PAYLOAD", TakeAwayIcon)
  //   return (
  //     <Grid container direction="row">
  //       <Box width={32} height={24} style={{backgroundImage:`url(${TakeAwayIcon})`}}/>
  //       <img src={TakeAwayIcon} style={{width:24}} alt="TakeAway" />
  //       <Typography>{payload[0].value}</Typography>
  //       <img src={DeliveryIcon} style={{width:24}} alt="Delivery"/>
  //       <Typography>{payload[1].value}</Typography>
  //     </Grid>
  //   )
  // }
  render(){
    const {theme,info, title, unit} = this.props
    return (
      <Card style={{marginTop:0, paddingTop:2, paddingBottom:2}}>
        {/* <CardHeader title={info.stsDate} titleTypographyProps={{variant:"h3"}}></CardHeader> */}
        <CardContent style={{paddingTop:2, paddingBottom:2}}>
          <Grid container direction="row">
            <Grid item xs={4}>
              <Typography style={{fontWeight:"bold"}}>
                {title}
              </Typography>            
              <Grid item container direction="row">
                <Typography>
                  Cantidad de pedidos:
                </Typography>
                <Typography>
                    {info.stsMenuQt}
                </Typography>            
              </Grid>
              <Grid item container direction="row">
                <Typography>
                  Importe total:
                </Typography>
                <Typography>
                    {Util.formatCurrency(info.stsTotal)}
                  </Typography>
              </Grid>
            </Grid>
            <Grid item xs={4}>
              <ResponsiveContainer width="100%" height={120}>
                <PieChart>
                  <Legend align="center" verticalAlign fontSize={12}
                  // content={this.renderTypeLegend}
                  />
                  <Pie
                    data={[
                      { name: 'TakeAway', value: unit=="Qt"?info.stsTakeAwayQt:info.stsTakeAwayTotal },
                      { name: 'Delivery', value: unit=="Qt"?info.stsDeliveryQt:info.stsDeliveryTotal },
                      { name: 'Mesa', value: unit=="Qt"?info.stsTableQt:info.stsTableTotal }
                    ]}
                    nameKey="name"
                    dataKey="value"
                    cx={"50%"}
                    cy={100}
                    startAngle={180}
                    endAngle={0}
                    outerRadius={50}
                    labelLine={false}
                    label={{offsetRadius:1}}
                  >                
                      <Cell key="takeAway" fill="#A40505" fontSize={12}/>
                      <Cell key="delivery" fill="#E10707" fontSize={12}/>
                      <Cell key="table" fill="#C95933" fontSize={12}/>
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </Grid>
            <Grid item xs={4}>
            <ResponsiveContainer width="100%" height={120}>
                <PieChart>
                  <Legend align="center" verticalAlign fontSize={12}/>
                  <Pie
                    data={[
                      { name: 'Efectivo', value: unit=="Qt"?info.stsCashQt:info.stsCashTotal },
                      { name: 'Tarjeta', value: unit=="Qt"?info.stsCardQt:info.stsCardTotal }
                    ]}
                    nameKey="name"
                    dataKey="value"
                    cx={"50%"}
                    cy={100}
                    startAngle={180}
                    endAngle={0}
                    outerRadius={50}
                    labelLine={false}
                    label={{offsetRadius:1}}
                  >                
                      <Cell key="cash" fill="#FF5733" fontSize={12}/>
                      <Cell key="card" fill="#FFA200" fontSize={12}/>
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
            </Grid>      
          </Grid>

        </CardContent>
      </Card>
    )
  }
}

export default withTheme(StatCard)


// WEBPACK FOOTER //
// ./src/components/Stats/StatCard.js